import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode, faX, faFolderClosed } from "@fortawesome/free-solid-svg-icons";
import { QRCodeSVG } from "qrcode.react";

const SpeakerNav = ({
  openQRCode,
  setOpenQRCode,
  handleEndPresentation,
  getAttendeeUrl,
}) => {
  return (
    <nav className="flex justify-end gap-6 py-[0.4vw] px-[0.4vw] border-b bg-white shadow-sm">
      <div className="flex items-center gap-3 w-full md:w-auto justify-between md:justify-end">
        <button
          onClick={() => setOpenQRCode(!openQRCode)}
          className="py-[0.5vw] px-[0.5vw] rounded-[0.5vw] text-lightPurple font-medium hover:bg-slate-100 text-[1vw]"
        >
          <FontAwesomeIcon icon={faQrcode} />
        </button>

        {openQRCode && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div
              className="bg-white rounded-[0.5vw] px-[0.5vw] py-[1.5vw] w-[80%] max-w-[50vw] max-h-[40vw] overflow-y-auto relative "
              style={{ scrollbarWidth: "thin" }}
            >
              <button
                onClick={() => setOpenQRCode(false)}
                className="absolute top-3 right-4 text-gray-700 hover:text-gray-900 font-bold text-[1vw]"
              >
                <FontAwesomeIcon icon={faX} size="md" />
              </button>

              <div className="flex flex-col items-center justify-center my-6">
                <h3 className="text-[1.3vw] font-bold text-lightPurple">
                  <FontAwesomeIcon icon={faQrcode} className="mx-[0.5vw]" />
                  Join the Presentation
                </h3>

                <p className="text-[0.9vw] text-gray-500 text-center my-[0.9vw] px-4">
                  Scan the QR code below with your smartphone camera to join the presentation.
                </p>

                <QRCodeSVG
                  value={getAttendeeUrl()}
                  size={350}
                  level="M"
                  bgColor="#ffffff"
                  fgColor="#109bd8"
                  includeMargin={false}
                />

                <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                  <p className="text-[0.8vw] text-gray-600 text-center">
                    Or visit: <br />
                    <a
                      href={getAttendeeUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-mono text-[0.7vw] text-blue-600 break-all"
                    >
                      {getAttendeeUrl()}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={handleEndPresentation}
          className="px-[0.8vw] py-[0.3vw] rounded-[0.5vw] border border-red-500 text-red-500 font-medium hover:text-white hover:bg-red-500 text-[1vw]"
        >
          <FontAwesomeIcon icon={faFolderClosed} className="mr-2" />
          End Presentation
        </button>
      </div>
    </nav>
  );
};

export default SpeakerNav;